
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";


export const EmployementHistoryEdit = ({
  onSuccess,
  setOpen,
  open,
  resourceId,
  setValue0,
  value,
}) => {
  return (
    <FormDialog
      maxWidth={"md"}
      open={open > 0}
      onSuccess={onSuccess}
      setOpen={setOpen}
      url={open === 1 ? "/api/resource/employment-history/:resourceId" : `/api/resource/employment-history/update/${resourceId}`}
      title={open === 1 ? "Create Employement History" : "Edit Employement History"}
      fields={[
        {
          name: "employementRecords",
          label: "Employement History (Start with the most recent)",
          type: "array",
          value: value["employementRecords"],
          setValue: (val) => setValue0("employementRecords", val),

          itemLabel: (index, values) => {
            const record = values[index];
            return `Employement #${index + 1}`;
          },
          fields: [
            {
              name: "companyName",
              label: "Company Name",
              required: true,
              type: "text",
              value: (index) => value?.employementRecords?.[index]?.companyName || "",
              setValue: (val, index) => {
                const updatedRecords = [...(value?.employementRecords || [])];
                updatedRecords[index] = { ...updatedRecords[index], companyName: val };
                setValue0("employementRecords", updatedRecords);
              },
            },
            {
              name: "employerName",
              label: "Employer Name",
              type: "text",
              required: true,
              value: (index) => value?.employementRecords?.[index]?.employerName || "",
              setValue: (val, index) => {
                const updatedRecords = [...(value?.employementRecords || [])];
                updatedRecords[index] = { ...updatedRecords[index], employerName: val };
                setValue0("employementRecords", updatedRecords);
              },
            },
            {
              name: "employerMobile",
              label: "Employer Mobile",
              type: "tel",
              required: true,
              value: (index) => value?.employementRecords?.[index]?.employerMobile || "",
              setValue: (val, index) => {
                const updatedRecords = [...(value?.employementRecords || [])];
                updatedRecords[index] = { ...updatedRecords[index], employerMobile: val };
                setValue0("employementRecords", updatedRecords);
                
              },
            },
            {
              name: "position",
              label: "Employement Position",
              type: "text",
              required: true,
              value: (index) => value?.employementRecords?.[index]?.position || "",
              setValue: (val, index) => {
                const updatedRecords = [...(value?.employementRecords || [])];
                updatedRecords[index] = { ...updatedRecords[index], position: val };
                setValue0("employementRecords", updatedRecords);
              },
            },
            {
              name: "jobStartDate",
              label: "Started At",
              type: "date",
              required: true,
              value: (index) => value?.employementRecords?.[index]?.jobStartDate || "",
              setValue: (val, index) => {
                const updatedRecords = [...(value?.employementRecords || [])];
                updatedRecords[index] = { ...updatedRecords[index], jobStartDate: val };
                setValue0("employementRecords", updatedRecords);
              },
              validate: (v) => {
                if (!v) return "Start date is required";
                const today = moment().startOf("day");
                if (moment(v).isAfter(today)) {
                  return "Start date must be in the past";
                }
                return true;
              },
            },
            {
              name: "jobEndDate",
              label: "Ended At",
              type: "date",
              required: true,
              value: (index) => value?.employementRecords?.[index]?.jobEndDate || "",
              minDate: (index) => value?.employementRecords?.[index]?.jobStartDate || "",
              setValue: (val, index) => {
                const updatedRecords = [...(value?.employementRecords || [])];
                updatedRecords[index] = { ...updatedRecords[index], jobEndDate: val };
                setValue0("employementRecords", updatedRecords);
              },
              validate: (v) => {
                const index = value?.employementRecords?.findIndex((r) => r?.jobEndDate === v);
                const startDate = value?.employementRecords?.[index]?.jobStartDate;

                if (!v && startDate) return "End date is required if start date is provided";
                if (!v) return "End date is required";
                if (startDate && moment(v).isBefore(moment(startDate))) {
                  return "End date cannot be before start date";
                }
                const today = moment().startOf("day");
                if (moment(v).isAfter(today)) {
                  return "End date must be in the past";
                }

                return true;
              }
            }
          ]

        },
      ]
      }
    />
  );
};